/**
 * Configuración del sistema de carga de Excel
 * Parámetros centralizados para control del comportamiento del loader
 */

const LoaderConfig = {
    // Configuración de reintentos
    retry: {
        maxAttempts: 5,              // Número máximo de intentos
        baseDelay: 1000,             // Delay base en ms (1 segundo)
        maxDelay: 16000,             // Delay máximo en ms (16 segundos)
        exponentialBase: 2,          // Base para cálculo exponencial
        jitterPercent: 0.2,          // Variación aleatoria (±20%)
        timeoutPerRequest: 10000     // Timeout por petición individual (10s)
    },

    // Configuración de caché
    cache: {
        enabled: true,               // Habilitar sistema de caché
        dbName: 'ProblemasDB',       // Nombre de la base de datos IndexedDB
        storeName: 'excelFiles',     // Nombre del store
        version: 1,                  // Versión del esquema
        maxAge: 7 * 24 * 60 * 60 * 1000, // Edad máxima del caché (7 días)
        useStaleOnError: true        // Usar caché antiguo si falla la carga
    },

    // Configuración de verificación
    verification: {
        checkServerHealth: true,     // Verificar estado del servidor antes de cargar
        checkFileExists: true,       // Verificar existencia del archivo (HEAD request)
        minFileSize: 1000,           // Tamaño mínimo esperado del archivo (bytes)
        maxFileSize: 10 * 1024 * 1024, // Tamaño máximo esperado (10 MB)
        validateContent: true        // Validar que el contenido es un Excel válido
    },

    // Configuración de UI
    ui: {
        showLoadingIndicator: true,  // Mostrar indicador de carga
        showProgressBar: true,       // Mostrar barra de progreso
        showRetryCount: true,        // Mostrar número de intento
        detailedErrors: true,        // Mostrar errores detallados
        allowCancel: false           // Permitir cancelar la carga (deshabilitado por ahora)
    },

    // Configuración de diagnóstico
    diagnostics: {
        debugMode: false,            // Modo debug (más logs)
        logTimings: true,            // Registrar tiempos de carga
        logErrors: true,             // Registrar errores detallados
        saveErrorLog: true           // Guardar log de errores en localStorage
    },

    // Rutas de archivos a intentar (en orden de prioridad)
    filePaths: [
        'problemas_23.xlsx',
        './problemas_23.xlsx'
    ],

    // Mensajes de error personalizados
    errorMessages: {
        networkError: 'Error de red. Verifica tu conexión a internet.',
        serverError: 'El servidor no responde. Asegúrate de que el servidor está ejecutándose (INICIAR.bat).',
        fileNotFound: 'No se encontró el archivo Excel. Verifica que "problemas_23.xlsx" existe en la carpeta del proyecto.',
        corruptFile: 'El archivo Excel parece estar corrupto. Intenta descargarlo de nuevo.',
        timeout: 'La carga del archivo está tardando demasiado. Verifica tu conexión.',
        parseError: 'Error al procesar el archivo Excel. Verifica que el formato es correcto.',
        cacheError: 'Error al acceder al caché del navegador.',
        unknown: 'Error desconocido al cargar la base de datos.'
    }
};

// Exponer configuración globalmente
window.LoaderConfig = LoaderConfig;

console.log('⚙️ LoaderConfig cargado');
